function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, JSON, Object) {
    var h = require("panel").h;
    var jade_mixins = {},
      $mixins = jade_mixins;
    jade_mixins['chart-legend'] = function() {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(($helpers.hasLegendSection()) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-chart-legend", {
            "attrs": __vjadeStringifyAttrsIfObj({
              height: `${$helpers.getChartLegendHeight()}px`,
              'sections': JSON.stringify($helpers.getLegendSection()),
              'enable-search': true,
              'show-select-all': true,
              'theme': legendScheme,
            }),
            "on": {
              togglecheckbox: $helpers.passThrough,
            },
            "class": {
              [`legend-theme-${legendScheme}`]: true
            },
          }));;
          return __jade_nodes
        }).call(this)) : undefined);;
        return __jade_nodes
      }).call(this);
    };

    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }
    const legendScheme = $attr(`legend-theme`);
    return {
      value: (h("div", {
        "class": {
          'legend-line-chart': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(($attr(`has-no-data`)) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("slot", {
            "attrs": __vjadeStringifyAttrsIfObj({
              name: `empty-state`
            }),
          }));;
          return __jade_nodes
        }).call(this)) : ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": Object.assign({}, {
              [`legend-theme-${legendScheme}`]: true
            }, {
              'body': true
            }),
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat((legendScheme === $helpers.ChartLegendTheme.CardTable) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(jade_mixins['chart-legend'].call(this));;
              return __jade_nodes
            }).call(this)) : undefined);
            __jade_nodes = __jade_nodes.concat(h("mp-line-chart", {
              "props": $helpers.getLineChartProps(),
              "attrs": __vjadeStringifyAttrsIfObj($helpers.getLineChartAttrs()),
              "class": {
                'has-legend': $helpers.hasLegendSection()
              },
            }));
            __jade_nodes = __jade_nodes.concat((legendScheme !== $helpers.ChartLegendTheme.CardTable) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(jade_mixins['chart-legend'].call(this));;
              return __jade_nodes
            }).call(this)) : undefined);;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;